module.exports = "<jujo_component specialized=\"true\" comp=\"modeling_group/svg_instance_editor\"></jujo_component>"